import gql from 'graphql-tag';

export default gql`
  fragment prospectPoolTotalScoreRankAccountStandardItemHistoryFragment on ProspectPoolTotalScoreRankAccountStandardItemHistory {
    id
    fieldType
    direction
    fieldName
    fromScore
    toScore
    prospectPoolTotalScoreRankHistoryId
    createdAt
    updatedAt
  }
`;

